import React, { useState, useEffect, useRef } from 'react';

const getSymbol = (code) => {
  const symbols = { USD: '$', EUR: '€', GBP: '£', CAD: '$', AUD: '$' };
  return symbols[code] || code;
};

export const AnimatedPrice = ({ price, currency, className = "" }) => {
  const [displayPrice, setDisplayPrice] = useState({ 
    val: price, 
    curr: currency,
    key: Date.now() // Unique key to trigger animation
  });
  
  const [prevPrice, setPrevPrice] = useState(null);

  useEffect(() => {
    // If price or currency changed
    if (price !== displayPrice.val || currency !== displayPrice.curr) {
      // Set the current displayed price as "Previous" (to animate out)
      setPrevPrice({
        val: displayPrice.val,
        curr: displayPrice.curr,
        key: displayPrice.key
      });

      // Set the new price (to animate in)
      setDisplayPrice({
        val: price,
        curr: currency,
        key: Date.now()
      });

      // Cleanup previous price after animation finishes (0.4s)
      const timer = setTimeout(() => {
        setPrevPrice(null);
      }, 400);

      return () => clearTimeout(timer);
    }
  }, [price, currency, displayPrice]);

  const format = (p, c) => `${getSymbol(c)}${p}`;

  return (
    <div className={`price-ticker-container ${className}`}>
      {/* NEW PRICE (Slides In from Bottom) */}
      <span key={displayPrice.key} className="price-ticker-item slide-in">
        {format(displayPrice.val, displayPrice.curr)}
      </span>

      {/* OLD PRICE (Slides Out to Top) */}
      {prevPrice && (
        <span key={prevPrice.key} className="price-ticker-item slide-out">
          {format(prevPrice.val, prevPrice.curr)}
        </span>
      )}
    </div>
  );
};